module.exports = __webpack_public_path__ + "static/media/bmcc.1aa331d8.svg";